module.exports = __webpack_public_path__ + "media/payment_icons/go_cardless-b0f2a145.svg";